import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardRouting } from './app.dashboard.routing';
import { LoginRouting } from './app.login.routing';
import { ErrorPageComponent } from '../../../_components/error-page/error-page.component';

const routes: Routes = [
    ...DashboardRouting,
    ...LoginRouting,
    { path: '', redirectTo: '', pathMatch: 'full' },
    { path: '**', component: ErrorPageComponent }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            routes,
            { useHash: true }
        )
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
